export default __webpack_public_path__ + "static/media/snare.9d22f293.wav";